import { useUserConfig } from "./useUserConfig";

/**
 * Returns workspace permissions for the user.
 *
 * canViewWorkspace: true if user is a workspace member (can see members list, read-only)
 * canManageWorkspace: true if user is admin (can create users, change roles, etc.)
 */
export function useUserWorkspace() {
  const { workspaces, isLoading, error } = useUserConfig();

  const defaultWorkspace = workspaces?.[0];

  const canManageWorkspace =
    defaultWorkspace?.permissions?.can_manage_members ?? false;

  const canViewWorkspace = defaultWorkspace?.permissions?.can_view ?? false;

  const canEditRoles = defaultWorkspace?.permissions?.can_edit_roles ?? false;

  return {
    workspaces,
    canManageWorkspace, // Admin only - can create users, change roles, etc.
    canViewWorkspace, // Any member - can see members list (read-only)
    canEditRoles,
    isLoading,
    error,
  };
}
